import { Row, Col, Card, Button, Space, Modal, Empty, Checkbox, Tooltip, message, Popconfirm, Spin, Tag, Layout, Input } from 'antd';
import { LockOutlined, UnlockOutlined, CheckCircleFilled, CheckOutlined, TrophyOutlined, LikeOutlined, UndoOutlined } from '@ant-design/icons';
import constants from '../../constants/constants';
import { useHistory } from "react-router";
import React, { useEffect, useState } from "react";
import { fetchApi, fetchAdminApi } from '../../services/api';
import { COOKIE, getCookie } from '../../services/cookie';
import { DOB } from '../../globalFunctions/GlobalFunctions'
import NotesModal from '../component/NotesModal';
const { Sider } = Layout;
const { TextArea } = Input;
const Dashboard = (props) => {
	const [isModalOpen, setisModalOpen] = useState(props && props.location && props.location.state && props.location.state.isPopUpMessage);
	const [sectionId] = useState(props && props.location && props.location.state && props.location.state.sectionId);
	const history = useHistory();
	const [dashboardData, setDashboarddata] = useState([]);
	const [showSection, setShowSection] = useState(false);
	const [isPaid, setIsPaid] = useState("");
	const [isSelfAssessmentComplete, setIsSelfAssessmentComplete] = useState(false);
	const [loading, setloading] = useState(false);
	const [loginType] = useState(getCookie(COOKIE.LoginType));
	const [adminClientValue, setAdminClientValue] = useState({});
	const [username] = useState(props && props.location && props.location.state);
	const [clientType, setClientType] = useState("");
	const [planId, setPlanId] = useState("");
	const [plans, setPlans] = useState([]);
	const [isMinor, setIsMinor] = useState(false);
	const [isRefresher, setIsRefresher] = useState(false);
	const [popOverDescription, setPopOverDescription] = useState("");
	const [isWorkbookComplete, setIsWorkbookComplete] = useState(false);
	const [isPopOverOpen, setIsPopOverOpen] = useState(false);
	const [sid, setSid] = useState("");
	const [clientDetails, setClientDetails] = useState([]);
	//notes
	const [noteValue, setNoteValue] = useState(null);
	const [noteTypeValue, setNoteTypeValue] = useState("0");
	const [notesVisible, setnotesVisible] = useState(false);
	const [notefollowUp, setNoteFollowUp] = useState(false);
	const [sessionChecked, setSessionChecked] = useState(false);
	const current = new Date();
	const [noteDate, setNoteDate] = useState({
		date: current.getDate(),
		month: String(current.getMonth() + 1).padStart(2, '0'),
		year: current.getFullYear()
	});
	const [isNoteAnswered, setIsNoteAnswered] = useState(false);
	// Slider for Summary
	const [collapsed, setCollapsed] = useState(false);
	const [summarySection, setSummarySection] = useState({
		summeryData: [],
		moreDetails: ""
	});
	const [summeryLoader, setSummeryLoader] = useState(false);
	const [assessmentBehavior, setAssessmentBehavior] = useState([]);
	const [showDischargeForm, setShowDischargeForm] = useState(false);
	useEffect(() => {
		if (props && props.location && props.location.state) {
			sessionStorage.setItem("adminClientValue", JSON.stringify(props.history.location.state));
		}
		if(props?.location?.state?.section_zero_counter){
			sessionStorage.setItem("count",props?.location?.state?.section_zero_counter);
		}else{
			sessionStorage.removeItem("count");
		}
		sessionStorage.removeItem("editedByClient");
		if (isModalOpen) {
			setTimeout(() => {
				setisModalOpen(false);
				history.replace({ state: null });
			}, 6000);
		}
		getDashBoardData();
	}, []);
	useEffect(() => {
		const onBackButtonClicked = () => {
			if (history?.location?.pathname === "/workbook-section-0") {
				history.push("/dashboard");
			}
		};
		window.addEventListener("popstate", onBackButtonClicked);
		return () => {
			window.removeEventListener("popstate", onBackButtonClicked);
		};
	}, []);
	const getClientDetails = (client_id) => {
		fetchAdminApi(`/client-profile/${client_id}`, "get",).then((res) => {
			if (res && res.data) {
				setClientDetails(res.data);
				if(loginType === "0"){
					sessionStorage.setItem("adminClientValue", JSON.stringify(res.data));
				}else{
					let payload = JSON.parse(sessionStorage.getItem("adminClientValue"));
					payload.enquiryId = res.data?.enquiry_info?.enquiry_id;
					sessionStorage.setItem("adminClientValue", JSON.stringify(payload));
				}
				if (res?.data?.plan_completed === 1 || res?.data?.is_active === "2") {
					setIsWorkbookComplete(true);
				} else {
					setIsWorkbookComplete(false);
				}
			} else {
				setClientDetails([]);
			}
		})
	};
	const handleCancel = () => {
		setisModalOpen(false);
		history.replace({ state: null });
	};
	//Function to get dashboard data
	const getDashBoardData = () => {
		// setShowSection(true);
		let clientId = null;
		let adminClientValuefromSession = JSON.parse(sessionStorage.getItem("adminClientValue"));
		setAdminClientValue(adminClientValuefromSession);
		if (props && props.location && props.location.state && props.location.state.isAdmin || adminClientValuefromSession?.isAdmin) {
			clientId = props && props.location && props.location.state && props.location.state.clientId || adminClientValuefromSession?.clientId;
		} else {
			clientId = getCookie(COOKIE.ClientId);
		}
		setloading(true);
		fetchApi(`/client-dashboard/${clientId}`, "get").then((res) => {
			getSummerySection(clientId);
			getClientDetails(clientId);
			setIsPaid(res?.is_paid);
			if (res?.data) {
				setClientType(res?.client_type);
				const resolvedPlanId = res?.plan_id ?? adminClientValuefromSession?.plan_id ?? null;
				setPlanId(resolvedPlanId);
				sessionStorage.setItem("plan_id", resolvedPlanId);
			}
			if (res && res.data && res.code === 200) {
				setloading(false);
				if (res && res.data && res.data.show_section === "A" && loginType === "0" || res.data.show_section === "B" && loginType === "0" || res.data.show_section === "C" && loginType === "0") {
					if (res?.data?.is_resume) {
						sessionStorage.setItem("count", res?.data?.is_resume);
					}
					sessionStorage.setItem("section_id", 0);
					const resolvedPlanId = res?.plan_id ?? adminClientValuefromSession?.plan_id ?? null;
					sessionStorage.setItem("plan_id", resolvedPlanId);
					if (res.data.show_section === "A") {
						history.push({ pathname: "workbook-section", state: { plan_id: resolvedPlanId } });
					}
					else if (res.data.show_section === "B") {
						setIsSelfAssessmentComplete(true);
					}
					else {
						history.push({ pathname: "workbook-section-0", state: { new_user: true, plan_id: resolvedPlanId } });
					}
				} else {
					setIsSelfAssessmentComplete(false);
					setClientType(res?.client_type);
					setPlanId(res?.plan_id ?? null);
					setDashboarddata(res.data);
					let latestSessionEnabled = res?.latest_section_enabled;
					sessionStorage.setItem("latestSessionEnabled", latestSessionEnabled);
					setShowSection(true);
					setShowDischargeForm(res?.show_discharge_plan === 1 ? true : false);
				}
			} else {
				setloading(false);
				setDashboarddata([]);
				if (res?.is_minor === "1") {
					setIsMinor(true);
				} else {
					setIsMinor(false);
				}
				if (adminClientValuefromSession?.isAdmin) {
					setShowSection(true);
				} else {
					setShowSection(false);
				}
				// setShowSection(true);
			}
			// setIsPaid(res?.is_paid);
			// if(res?.is_refresher === 1 && res?.is_paid === 1){
			// 	history.push({ pathname: "/refresher-workbook", });
			// }
			setIsRefresher(res?.is_refresher === 1 ? true : false);
		});
	};
	useEffect(() => {
		getPlans();
	}, []);
	const getPlans = async () => {
		try {
			const res = await fetchApi("/get-plans", "get");
			if (res?.data?.length) {
				setPlans(res.data);
			} else {
				message.error(res?.message);
				setPlans([]);
			}
		} catch (error) {
			message.error("Unable to fetch plans.");
		} finally {
		}
	};
	const getPlanConfig = () => {
		return plans.find(p => String(p.plan_id) === String(planId));
	};
	//Function to return card color
	const getCardColour = (status) => {
		if (status === "0") {
			return 'bg-slate-300 text-center h-36 text-slate-500 cursor-not-allowed';
		} else {
			return 'bg-amber-300 text-center h-36 cursor-pointer';
		}
	};
	//function to route to edited section workbook
	const getEditedSection = (sectionId, partId) => {
		sessionStorage.setItem('count', partId);
		// sessionStorage.setItem('editedByClient', true);
		sessionStorage.setItem('section_id', sectionId);
		sessionStorage.setItem('plan_id', planId);
		history.push({ pathname: '/workbook-section' });
	};
	const enableSection = (flag,sectionId) => {
		let payload = {};
		payload.section_id = sectionId;
		payload.plan_id = planId;
		payload.flag = flag;
		payload.is_admin = "1";
		setloading(true);
		fetchAdminApi(`/update-client-sections/${clientDetails?.client_id}`, "put", payload).then((res) => {
			if (res && res.code && res.code === 200) {
				getDashBoardData();
				message.success(res.message);
				setloading(false);
			} else {
				message.error("Failed to enable section.");
				setloading(false);
			}
		});
	};
	// const getSectionId = (section_url) => {
	// 	let url = section_url;
	// 	let url_length = url?.length;
	// 	let section_id = url?.charAt(url_length - 1);
	// 	setSid(section_url === "/refresher-workbook" ? "100" : section_id);
	// };
	const undoSection = (sectionid) => {
		let payload = {
			is_admin : "1",
			flag : "3",
			section_id: sectionid,
			plan_id: planId,
		};
		fetchAdminApi(`/update-client-sections/${adminClientValue?.clientId}`, "put", payload).then((res) => {
			if (res?.code === 200) {
				message.success(res.message);
				getDashBoardData();
			} else {
				message.error(res.message);
			}
		});
	};
	//Function to return card icon
	const getCardIcon = (status, sectionId, partId = null, label = "") => {
		// Non-addict: Section 1 and 301 is always unavailable
		if (clientType === "0" && (sectionId === 1 || sectionId === 301)) {
			status = "0";
		}

		switch (status) {
			case "0": {
				const planCompletedTip = clientDetails?.plan_completed === 1
					? `To Enable ${label}, Kindly uncheck the Plan Completed.`
					: "Unavailable";

				// Non-addict Section 1 and 303 is never enableable
				if (clientType === "0" && (sectionId === 1 || sectionId === 301)) {
					return <Tooltip title={planCompletedTip}><LockOutlined className='absolute bottom-0 right-0 p-2.5' /></Tooltip>;
				}

				// Same logic as before (section 8 can only be enabled once section 7 is completed)
				const canEnable =
					loginType !== "0" &&
					clientDetails?.plan_completed === 0 &&
					(sectionId !== 8 || dashboardData?.[7]?.[0]?.status === "3");

				if (canEnable) {
					return (
						<Popconfirm
							title={constants.EnableSection}
							description={`Are you sure you want to Enable ${label}?`}
							onConfirm={() => enableSection("1", sectionId)}
							okText="Yes"
							cancelText="No"
							icon={<UnlockOutlined className='!text-sky-500' />}
						>
							<Tooltip title="Enable"><LockOutlined className='absolute bottom-0 right-0 p-2.5' /></Tooltip>
						</Popconfirm>
					);
				}
				return <Tooltip title={planCompletedTip}><LockOutlined className='absolute bottom-0 right-0 p-2.5' /></Tooltip>;
			}
			case "1":
				return loginType === "0"
					? <Tooltip title="Available"><UnlockOutlined className='absolute bottom-0 right-0 p-2.5' /></Tooltip>
					: <Popconfirm
						title={constants.UnEnableSection}
						description={`Are you sure you want to UnEnable ${label}?`}
						onConfirm={() => enableSection("4", sectionId)}
						okText="Yes"
						cancelText="No"
						icon={<LockOutlined className='!text-sky-500' />}
					><Tooltip title="Available"><UnlockOutlined className='absolute bottom-0 right-0 p-2.5' /></Tooltip></Popconfirm>;
			case "2":
				return <Tooltip title="Submitted"><CheckCircleFilled className='absolute bottom-0 right-0 p-2.5 text-blue-600' /></Tooltip>;
			case "3":
				return loginType === "0"
					? <Tooltip title="Completed"><CheckCircleFilled className='absolute bottom-0 right-0 p-2.5 text-green-600' /></Tooltip>
					: <Popconfirm
						title="Undo Status"
						description="Are you sure you want to mark this as Not Complete?"
						onConfirm={() => undoSection(sectionId)}
						okText="Yes"
						cancelText="No"
						icon={<UndoOutlined className='!text-sky-500' />}
					><Tooltip title="Completed"><CheckCircleFilled className='absolute bottom-0 right-0 p-2.5 text-green-600' /></Tooltip></Popconfirm>;
			case "4":
				return <span className='absolute bottom-0 right-0 p-2.5'><span className="text-sm">Discussion In Progress </span><Tooltip title="Discussion In Progress"><CheckCircleFilled className='!align-middle text-orange-600' /></Tooltip></span>;
			case "5":
			case "6":
				return <span className='absolute bottom-0 right-0 p-2.5'><a onClick={() => getEditedSection(sectionId, partId)} className="text-sm">Edited </a><Tooltip title="Completed (Edited)"><CheckCircleFilled className={`!align-middle ${status === "6" ? "text-green-600" : "text-orange-600"}`} /></Tooltip></span>;
			case "7":
				return <Tooltip title="In Progress"><CheckCircleFilled className='absolute bottom-0 right-0 p-2.5 text-orange-600' /></Tooltip>;
			default:
				return null;
		}
	};
	//Function to disable card
	const isCardDisable = (status, section_id) => {
		if (status !== "0") {
			if (props && props.location && props.location.state && props.location.state.isAdmin === true || adminClientValue?.isAdmin) {
				history.push({
					pathname: section_id === 100 ? 'refresher-workbook' : 'workbook-section',
					state: {
						isAdmin: true,
						clientId: props && props.location && props.location.state && props.location.state.clientId || adminClientValue?.clientId,
						client_name: username?.client_name || adminClientValue?.client_name,
						status: status,
						section_id: section_id,
						plan_id: planId
					}
				});
			} else {
				sessionStorage.removeItem("adminClientValue");
				history.push({
					pathname: section_id === 100 ? 'refresher-workbook' : 'workbook-section',
					state: { 
						status: status,
						section_id: section_id,
						plan_id: planId
					}
				});
			}
		}
	};// ─── Plan-driven section rendering ───────────────────────────────
	const planSectionPrefix = { "1": "Immersion", "3": "IOP Section" };
	const DefaultSections = [1, 2, 3, 4, 5, 6, 7, 8]; // fallback if plans API hasn't loaded

	// Refresher client = has a different initial_client_id
	const isRefresherClient =
		clientDetails?.initial_client_id != null &&
		clientDetails?.client_id !== clientDetails?.initial_client_id;

	// Which sections to show for the current plan (order = API order)
	const getPlanSectionIds = (plan) => {
		if (isRefresherClient) return [100];
		if (!plan) return DefaultSections;

		let ids = plan.sections_exits;
		if (!ids?.length && plan.section_start != null && plan.section_count) {
			ids = Array.from({ length: Number(plan.section_count) }, (_, i) => Number(plan.section_start) + i + 1);
		}
		// 100 (refresher) only appears for refresher clients
		return (ids || []).map(Number).filter((id) => id !== 100);
	};

	// Label + subtitle for each card
	const getSectionMeta = (sectionId, plan, index) => {
		if (sectionId === 100) {
			return { label: constants.RefresherWorkSheet, subtitle: "" };
		}
		if (sectionId >= 301 && sectionId <= 313) {
			return { label: `TSF ${sectionId - 300}`, subtitle: "" };
		}
		if (sectionId >= 200 && sectionId <= 299) {
			return { label: `Week ${index + 1}`, subtitle: constants.weekSubtitles?.[index] || "" };
		}
		if (sectionId >= 1 && sectionId <= 8) {
			const prefix = planSectionPrefix[String(plan?.plan_id)] ?? "Section";
			return { label: `${prefix} ${sectionId}`, subtitle: constants[`sec${sectionId}sub`] || "" };
		}
		return { label: `Section ${sectionId}`, subtitle: "" };
	};

	const renderDashboardCards = () => {
		const plan = getPlanConfig();
		const sectionIds = getPlanSectionIds(plan);

		const footer = (
			<Col span={24}>
				{loginType === "1" || loginType === "2" ? <div className='float-left'>{planCompletedComponant}</div> : null}
				{legendTags}
			</Col>
		);

		if (sectionIds.length === 0) {
			return (
				<Row gutter={[24, 24]}>
					<Col span={24}>
						<Empty description={`No section data available for ${plan?.name ?? "this plan"} yet.`} />
					</Col>
					<Col span={24}>{legendTags}</Col>
				</Row>
			);
		}

		return (
			<Row gutter={[24, 24]}>
				{sectionIds.map((sectionId, index) => {
					const sectionData = dashboardData?.[sectionId]?.[0];
					const isNonApplicable = clientType === "0" && (sectionId === 1 || sectionId === 301);
					const status = isNonApplicable ? "0" : (sectionData?.status ?? "0");
					const partId = sectionData?.part_id ?? null;
					const { label, subtitle } = getSectionMeta(sectionId, plan, index);

					return (
						<Col key={sectionId} xs={24} md={12} lg={6}>
							<Card styles={{ body: { height: "100%" } }} size="small" className={getCardColour(status)} onClick={() => isCardDisable(status, sectionId)}>
								<div className='h-4/5'>
									<span className='text-lg font-bold'>{label}</span>
									{subtitle && <><br /><span className='text-sm'>{subtitle}</span></>}
									{isNonApplicable && (
										<span className='absolute bottom-0 left-0 p-2.5 text-sm'>Non Applicable</span>
									)}
								</div>
								{getCardIcon(status, sectionId, partId, label)}
							</Card>
						</Col>
					);
				})}
				{footer}
			</Row>
		);
	};

	const redirectToSuicideForm = () => {
		sessionStorage.setItem("count", 1);
		sessionStorage.setItem("section_id", "0");
		window.open(constants.BaseUrl + "/suicidal-form");
	};

	const redirectToScreening = () => {
		sessionStorage.removeItem("assessmentQuestions");
		window.open(constants.BaseUrl + "/screening-form");
	};
	
	const redirectToRecovryPlan = () => {
		window.open(constants.BaseUrl + "/recovery-plan");
	};

	const redirectToSelfAssessmentForm = () => {
		sessionStorage.removeItem('adminClientValue');
		sessionStorage.setItem("adminClientValue", JSON.stringify(clientDetails));
		window.open(constants.BaseUrl + "/self-assessment-summary");
	};

	const redirectToDASTTest = () => {
		sessionStorage.setItem('count', 1);
		sessionStorage.setItem("section_id", "0");
		window.open(constants.BaseUrl + "/workbook-tests");
	};

	const redirectToCommitmentForm = () => {
		sessionStorage.setItem("count", JSON.stringify(1));
		sessionStorage.setItem("section_id", "0");
		window.open(constants.BaseUrl + "/commitment-form");
	};

	const redirectToCoachingAgreement = () => {
		sessionStorage.setItem("count", JSON.stringify(1));
		sessionStorage.setItem("section_id", "0");
		sessionStorage.setItem("plan_id", planId);
		window.open(constants.BaseUrl + "/coaching-form");
	};

	const redirectToDischargePlan = () => {
		let url = "/discharge-plan";
		let payload = {
			client_name: clientDetails.client_firstname + " " + clientDetails.client_lastname,
			client_serial_number: clientDetails?.client_serial_number,
			recoveryplan: clientDetails?.recovery_plan_answers
		};

		if (clientDetails?.client_id) {
			payload.clientId = clientDetails?.client_id
		}
		sessionStorage.setItem("adminClientValue", JSON.stringify(payload));
		window.open(constants.BaseUrl + url);
	};

	const redirectToFilesListing = () => {
		sessionStorage.clear();
		let payload = {
			clientId:  clientDetails?.client_id,
			client_serial_number: clientDetails?.client_serial_number,
			client_name: clientDetails?.firstname + " " + clientDetails?.lastname
		};
		sessionStorage.setItem("adminClientValue", JSON.stringify(payload));
		window.open(constants.BaseUrl + "/documents");
	};
	const getMedicalForm = () => {
		sessionStorage.clear();
		let payload = {
			clientId:  clientDetails?.client_id,
			client_name: clientDetails?.firstname + " " + clientDetails?.lastname,
			is_medical_info : true
		};
		sessionStorage.setItem("adminClientValue", JSON.stringify(payload));
		window.open(constants.BaseUrl + "/medical-info");
	};
	const redirectToEditProfile = () => {
		window.open(constants.BaseUrl + "/edit-client");
	};
	const routeToListNotes = () => {
		window.open(constants.BaseUrl + "/notes");
	};

	const handleRedirect = () => {
		if (adminClientValue?.clientId) {
			history.push("/view-client");
		} else {
			history.push("/view-enquiry");
		}
	};

	const handleBackClick = () => {
		if (history.length > 1) {
			history.goBack();
		} else {
			handleRedirect();
		}
	};

	// Reusable button component at the top of the file
	const WbButton = ({ onClick, children }) => (
		<Button
			size="small"
			className="text-xs font-semibold bg-sky-800 text-white uppercase"
			onClick={onClick}
		>
			{children}
		</Button>
	);

	const userHeader = () => {
		const currentPlan = getPlanConfig();
		const planName = currentPlan?.name || "";
		return <>
			<Col span={24} className="flex flex-col gap-y-2">
				{/* ── Row 1: Title / Username ── */}
				<div>
					{loginType === "1" || loginType === "2" ? (
						<span onClick={() =>
							history.push({
								pathname: "/edit-client",
								state: { client_id: adminClientValue?.clientId },
							})
						}
							className="font-semibold text-base text-black cursor-pointer"
						>
							{planName && (
								<>
									<span>
										{planName}
									</span>
									{" "}
								</>
							)}{constants.AdminWorkbook} -{" "}
							{username?.client_name ?? adminClientValue?.client_name}{" "}
							{`(#${username?.client_serial_number ?? adminClientValue?.client_serial_number})`}
						</span>
					) : (
						<span className="font-semibold text-base text-black">
							{constants.MyWorkbook}
							{planName && (
								<>
									{" - "}
									<span>
										{planName}
									</span>
								</>
							)}
						</span>
					)}
				</div>

				{/* ── Row 2: Buttons ── */}
				<Space size="small" wrap>
					{loginType === "1" || loginType === "2" ? (
						// Admin / loginType 1 & 2 buttons
						<>
							<WbButton onClick={handleBackClick}>{constants.BackBtn}</WbButton>
							<WbButton onClick={routeToListNotes}>{constants.ViewNotes}</WbButton>
							<WbButton onClick={addNotes}>{constants.AddNote}</WbButton>
							{showSection && (
								<WbButton onClick={() => setCollapsed(!collapsed)}>
									{collapsed ? "Show" : "Hide"} Summary
								</WbButton>
							)}
							<WbButton onClick={redirectToScreening}>{constants.ScreeningForm}</WbButton>
							<WbButton onClick={redirectToRecovryPlan}>{constants.IndividualRecoveryPlan}</WbButton>
							{clientDetails?.show_suicidal_consent === 1 && (
								<WbButton onClick={redirectToSuicideForm}>{constants.SuicideForm}</WbButton>
							)}
							<WbButton onClick={redirectToFilesListing}>{constants.DocumentList}</WbButton>
							{clientDetails?.show_selfassesment === 1 && (
								<WbButton onClick={redirectToSelfAssessmentForm}>{constants.SelfAssessment}</WbButton>
							)}
							{clientDetails?.show_coaching_agreement === 1 && (
								<WbButton onClick={redirectToCoachingAgreement}>{constants.CoachingAgreement}</WbButton>
							)}
							{clientDetails?.show_tests === 1 && (
								<WbButton onClick={redirectToDASTTest}>{constants.Tests}</WbButton>
							)}
							{clientDetails?.show_commitment_to_privacy === 1 && (
								<WbButton onClick={redirectToCommitmentForm}>{constants.CommitmentToPrivacy}</WbButton>
							)}
							<WbButton onClick={redirectToEditProfile}>Profile</WbButton>
						</>
					) : dashboardData.length === 0 ? (
						// Client — no dashboard data yet
						<>
							<WbButton onClick={getMedicalForm}>{constants.ReleaseForm}</WbButton>
							<WbButton onClick={() => history.push("/my-profile")}>{constants.MyProfileText}</WbButton>
							{clientDetails?.show_selfassesment === 1 && (
								<WbButton onClick={redirectToSelfAssessmentForm}>{constants.SelfAssessment}</WbButton>
							)}
							{clientDetails?.show_coaching_agreement === 1 && (
								<WbButton onClick={redirectToCoachingAgreement}>{constants.CoachingAgreement}</WbButton>
							)}
							{clientDetails?.show_tests === 1 && (
								<WbButton onClick={redirectToDASTTest}>{constants.Tests}</WbButton>
							)}
							{clientDetails?.show_commitment_to_privacy === 1 && (
								<WbButton onClick={redirectToCommitmentForm}>{constants.CommitmentToPrivacy}</WbButton>
							)}
								{showDischargeForm && (
									<WbButton onClick={redirectToDischargePlan}>{constants.DischargePlan}</WbButton>
								)}
						</>
					) : (
						// Client — has dashboard data
						<>
							{showSection && (
								<WbButton onClick={() => setCollapsed(!collapsed)}>
									{collapsed ? "Show" : "Hide"} Summary
								</WbButton>
							)}
							<WbButton onClick={redirectToScreening}>{constants.ScreeningForm}</WbButton>
							<WbButton onClick={redirectToRecovryPlan}>{constants.IndividualRecoveryPlan}</WbButton>
							{clientDetails?.show_suicidal_consent === 1 && (
								<WbButton onClick={redirectToSuicideForm}>{constants.SuicideForm}</WbButton>
							)}
							<WbButton onClick={redirectToFilesListing}>{constants.DocumentList}</WbButton>
							<WbButton onClick={getMedicalForm}>{constants.ReleaseForm}</WbButton>
							{clientDetails?.show_selfassesment === 1 && (
								<WbButton onClick={redirectToSelfAssessmentForm}>{constants.SelfAssessment}</WbButton>
							)}
							{clientDetails?.show_coaching_agreement === 1 && (
								<WbButton onClick={redirectToCoachingAgreement}>{constants.CoachingAgreement}</WbButton>
							)}
							{clientDetails?.show_tests === 1 && (
								<WbButton onClick={redirectToDASTTest}>{constants.Tests}</WbButton>
							)}
							{clientDetails?.show_commitment_to_privacy === 1 && (
								<WbButton onClick={redirectToCommitmentForm}>{constants.CommitmentToPrivacy}</WbButton>
							)}
							<WbButton onClick={() => history.push("/my-profile")}>{constants.MyProfileText}</WbButton>
									{showDischargeForm && (
										<WbButton onClick={redirectToDischargePlan}>{constants.DischargePlan}</WbButton>
									)}
						</>
					)}
				</Space>
			</Col>
		{loginType === "1" && (
			<>
				<div className='mt-2'>
					<div className="flex flex-col sm:flex-row items-start !gap-1 sm:gap-4">
						<div className="sm:min-w-[160px] font-semibold text-gray-800">
							{constants.NonBillable} :
						</div>
						<div className="flex flex-wrap gap-2">
							{clientDetails?.total_sessions?.non_billable?.length > 0 ? (
								clientDetails?.total_sessions?.non_billable?.map((val, index) => (
									<div
										key={index}
										className="flex items-center gap-1 bg-white px-3 py-1 rounded shadow text-sm"
									>
										<span className="font-semibold text-gray-800">{val.name}</span>
										<span className="text-gray-500">:</span>
										<span className="text-gray-800 font-medium">{val.notes}</span>
									</div>
								))
							) : (
								null
							)}
						</div>
					</div>
				</div>
				<div className='mt-2'>
					<div className="flex flex-col sm:flex-row items-start !gap-1 sm:gap-4">
						<div className="sm:min-w-[160px] font-semibold text-gray-800">
							{constants.Billable} :
						</div>
						<div>
							<div className="flex flex-wrap gap-2">
								{clientDetails?.total_sessions?.billable?.length > 0 ? (
									clientDetails?.total_sessions?.billable?.map((val, index) => (
										<div
											key={index}
											className="flex items-center gap-1 bg-white px-3 py-1 rounded shadow text-sm"
										>
											<span className="font-semibold text-gray-800">{val.name}</span>
											<span className="text-gray-500">:</span>
											<span className="text-gray-800 font-medium">{val.notes}</span>
										</div>
									))
								) : (
									null
								)}
							</div>
						</div>
					</div>
				</div>
			</>
		)}
		</>
	};
	const addNotes = () => {
		if (clientDetails.is_note_answered === 0) {
			window.open(constants.BaseUrl + "/add-note");
		} else {
			document.getElementById('top').scrollIntoView({ behavior: "smooth" });
			getForm(noteTypeValue);
			setnotesVisible(true);
		}
	};
	const getForm = (formType) => {
		let adminClientValuefromSession = JSON.parse(sessionStorage.getItem("adminClientValue"));
		setNoteTypeValue(formType);
		let payload = { note_type: formType };
		payload.client_id = props && props.location && props.location.state && props.location.state.clientId || adminClientValuefromSession?.clientId;
		fetchAdminApi("/notes", 'post', payload).then((res) => {
			if (res?.code === 200) {
				setNoteValue(res?.data?.data);
				if (res?.data?.is_note_answered === 1) {
					setIsNoteAnswered(true);
				} else {
					setIsNoteAnswered(false);
				}
			} else {
				setNoteValue([]);
			}
		});
	};
	const hideModal = () => {
		setNoteValue(null);
		setNoteTypeValue("0");
		setnotesVisible(false);
		setNoteFollowUp(false);
		setSessionChecked(false);
	};
	const onchangeNoteValue = (e, index) => {
		setNoteValue(prev => {
			const updated = [...prev];
			updated[index] = e;
			return updated;
		});
	};
	const createNote = (type) => {
		let adminClientValuefromSession = JSON.parse(sessionStorage.getItem("adminClientValue"));
		let assessmentText = '';
		if (noteValue[1]) {
			assessmentText = "<b><u>ASSESSMENT:</u></b> " + noteValue[1];
		} else if (assessmentBehavior?.length > 0) {
			assessmentText = "<b><u>ASSESSMENT:</u></b> ";
		}

		let admin_id = getCookie(COOKIE.ClientId);
		let payload = {
			client_id: props && props.location && props.location.state && props.location.state.clientId || adminClientValuefromSession?.clientId,
			notes_content: noteValue[0] ? "<b><u>DATA:</u></b>" + " " + noteValue[0] : "",
			notes_assesment: assessmentText,
			notes_plan: noteValue[2] ? "<b><u>PLAN:</u></b>" + " " + noteValue[2] : "",
			section_id: null,
			admin_id: admin_id,
			notes_type: noteTypeValue,
			dt_created: `${noteDate.year}-${noteDate.month}-${noteDate?.date}`
		};
		if (noteTypeValue === "0") {
			const clientName = clientDetails?.client_firstname || "Client";

			const behaviorSentence = assessmentBehavior?.length > 0
				? `<h3>${clientName} ${assessmentBehavior?.join(', ')}.</h3>`
				: '';

			payload.notes_assesment_behaviour = behaviorSentence;
			payload.answers = {
				...(payload.answers || {}),
				follow_up: notefollowUp ? 1 : 0,
				assessment_behavior: assessmentBehavior
			};
		}
		if (sessionChecked === true) {
			payload.session_checked = sessionChecked;
		}
		if (type === "esign") {
			payload.signed_by = admin_id;
		}
		if (noteValue !== null) {
			fetchAdminApi(`/add-notes`, "post", payload).then((res) => {
				if (res && res.code && res.code === 200) {
					setNoteDate({
						...noteDate,
						date: current.getDate(),
						month: String(current.getMonth() + 1).padStart(2, '0'),
						year: current.getFullYear()
					});
					setAssessmentBehavior([]);
					message.success(res.message);
				} else {
					message.error(res.message);
				}
			});
		}
		hideModal();
	};
	//date of notes date onchange
	const handleNoteDayChange = (value) => {
		setNoteDate({
			...noteDate,
			date: value
		});
	};
	const handleNoteMonthChange = (value) => {
		setNoteDate({
			...noteDate,
			month: value
		});
	};
	const handleNoteYearChange = (value) => {
		setNoteDate({
			...noteDate,
			year: value
		});
	};
	const onFollowUpChange = (checked) => {
		setNoteFollowUp(checked);

		const firstName = clientDetails?.client_firstname;

		if (checked) {
			onchangeNoteValue(constants.FollowUpData1 + `${firstName || "Client"}` + constants.FollowUpData2, 0);
			onchangeNoteValue(constants.FollowUpAssessment, 1);
			onchangeNoteValue(constants.FollowUpPlan, 2);
		} else {
			onchangeNoteValue("", 0);
			onchangeNoteValue("", 1);
			onchangeNoteValue("", 2);
		}
	};

	const onSessionChange = (value) => {
		setSessionChecked(value);
	}
	const onchangeWorkbookComplete = (e) => {
		if (e.target.checked === true) {
			setPopOverDescription("Are you sure you want to close the workbook section?");
		} else {
			setPopOverDescription("Are you sure you want to resume the workbook section?");
		}
		setIsWorkbookComplete(e.target.checked);
	};
	const confirm = () => {
		let payload = {
			client_id: clientDetails?.client_id,
			workbook_complete: isWorkbookComplete === true ? '1' : '0',
			plan_id: planId,
		};
		fetchAdminApi(`/workbook-complete`, "post", payload).then((res) => {
			if (res?.code === 200) {
				message.success(res.message);
				getDashBoardData();
				setIsPopOverOpen(false);
			} else {
				message.error(res.message);
				setIsPopOverOpen(false);
			}
		});
	};
	const cancel = () => {
		setIsPopOverOpen(false);
		setIsWorkbookComplete(clientDetails?.plan_completed === 0 || clientDetails?.is_active !== "2" ? false : true);
	};
	const showPopconfirm = () => {
		setIsPopOverOpen(true);
	};
	const planCompletedComponant = (
		<Popconfirm
			title={constants.PlanCompleted}
			description={popOverDescription}
			onConfirm={confirm}
			onCancel={cancel}
			open={isPopOverOpen.plan_completed}
			okText="Yes"
			cancelText="No"
			icon={<CheckOutlined className='!text-sky-500' />}
		>
			<Checkbox checked={isWorkbookComplete} onClick={showPopconfirm} onChange={onchangeWorkbookComplete}>{constants.PlanCompleted}</Checkbox>
		</Popconfirm>
	);
	const legendTags = (
		<Space className='w-full' size={[0, 8]} wrap>
			<Tag color="default" icon={<LockOutlined />}>Unavailable</Tag>
			<Tag color="default" icon={<UnlockOutlined />}>Available</Tag>
			<Tag color="orange" icon={<CheckCircleFilled />}>In Progress</Tag>
			<Tag color="blue" icon={<CheckCircleFilled />}>Submitted</Tag>
			<Tag color="green" icon={<CheckCircleFilled />}>Completed</Tag>
			<Tag color="orange" icon={<CheckCircleFilled />}>Discussion In Progress</Tag>
			<Tag color="green" icon={<CheckCircleFilled />}>Completed (Edited)</Tag>
		</Space>
	);
	const getSummerySection = (id) => {
		setSummeryLoader(true);
		fetchAdminApi(`/view-client-summary/${id}`, "get").then((res) => {
			if (res.code === 200) {
				setSummeryLoader(false);
				setSummarySection({
					summeryData: res?.data?.summary,
					moreDetails: res?.data?.more_details
				});
			} else {
				setSummeryLoader(false);
			}
		});
	};

	const handleAssessmentBehaviorChange = (value) => {
		setAssessmentBehavior(value);
	}

	return (
		<div>
			<div className='text-center bg-amber-300 text-lg font-semibold p-3'>{constants.Subtitle}
				<span className="py-0.5 px-3 ml-3 text-sm bg-white rounded-xl">Dashboard</span>
			</div>
			<div className='bg-amber-100 text-base font-semibold p-1.5 mb-3'><div className="container mx-auto">{userHeader()}</div></div>
			<div className='mx-6 mb-6 mt-3'>
				{showSection &&
					<Spin spinning={loading} size="large">
						<div className="mb-4">
							{renderDashboardCards()}
						</div>

						<Layout className="label-default bg-pattern" >
							<Sider className={`${collapsed ? 'h-0' : ""} !bg-transparent`} trigger={null} collapsible collapsed={collapsed} theme="light" width="100%" collapsedWidth={0}>
								<Spin spinning={summeryLoader} size="large">
									<div className="p-3 rounded-lg !bg-sky-100 h-full">
										<p className='mb-3'>
											<b>{constants.MoreDetails}</b>: {summarySection?.moreDetails}
										</p>
										<div>
											<h1 className="text-center"><strong>Summary</strong></h1>
											{
												summarySection.summeryData?.length > 0 ?
													<div>{summarySection.summeryData.map((data) => {
														return <div className='mt-2 px-2' key={data?.item_id}>
															<div className='mt-3 font-semibold' dangerouslySetInnerHTML={{ __html: data?.heading }} />
															<TextArea
																className={"bg-gray-200"}
																disabled={true}
																autoSize={true}
																readOnly={true}
																value={data?.response}
															/>
														</div>
													})}</div> : <div>No summary data</div>}
										</div>
									</div>
								</Spin>
							</Sider>
						</Layout>
					</Spin> 
				}
				{(isPaid === 0 || isSelfAssessmentComplete) && loginType === "0" ? (
					<Empty
						image={null}
						className="custom-ant-empty-image"
						description={
							<div className="text-center">
								<LikeOutlined className="text-8xl text-sky-800 mb-2.5" />
								<div className="text-lg">
									{
										isSelfAssessmentComplete ? constants.DashboardSelfAssessmentComMessage :
											isRefresher === false ?
												isMinor ?
													constants.DashboardWelcomeMessageMinor
													: clientDetails?.enquiry_info?.member_of !== null ? constants.DashboardWelcomeMessageFamilyMember : constants.DashboardWelcomeMessage
												: constants.DashboardWelcomeRefresher
									}
								</div>
							</div>
						}
					>
					</Empty>
				): null}
				{(isPaid == 1 && !showSection && loginType === "0") && (
					<Empty
						image={null}
						className="custom-ant-empty-image"
						description={
							<div className="text-center">
								<LikeOutlined className="text-8xl text-sky-800 mb-2.5" />
								<div className="text-lg">
									{constants.DashboardWelcomePayment}
								</div>
							</div>
						}
					/>
				)}
			</div>
			<Modal
				title={
					<div>
						<TrophyOutlined className="text-5xl text-sky-900" />
					</div>
				}
				open={isModalOpen}
				onCancel={handleCancel}
				footer={null}
				className="welcome-modal text-center"
				width={410}
			>
				<div className="text-2xl font-bold mb-2.5 text-sky-900">
					{constants.complete}
				</div>
				<div className="text-lg font-semibold text-slate-500" type="secondary">
					{constants.complete2} {sectionId}.
					{constants.complete3}
					{constants.complete4}
				</div>
			</Modal>
			{/* {noteValue && notesModel(hideModal, notesVisible, onchangeNoteValue, createNote, getForm, noteValue, noteTypeValue, isNoteAnswered, DOB(noteDate.month, handleNoteMonthChange, noteDate.date, handleNoteDayChange, noteDate.year, handleNoteYearChange, "Date", false), onSessionChange, sessionChecked, false, null, null, assessmentBehavior, handleAssessmentBehaviorChange)} */}
			{noteValue && (
				<NotesModal
					hideModal={hideModal}
					notesVisible={notesVisible}
					onchangeNoteValue={onchangeNoteValue}
					createNote={createNote}
					getForm={getForm}
					noteValue={noteValue}
					noteTypeValue={noteTypeValue}
					disable={isNoteAnswered}
					date={DOB(
						noteDate.month,
						handleNoteMonthChange,
						noteDate.date,
						handleNoteDayChange,
						noteDate.year,
						handleNoteYearChange,
						"Date",
						false
					)}
					onSessionChange={onSessionChange}
					sessionChecked={sessionChecked}
					isSessionPresent={false}
					nextPreviousButton={null}
					isEdit={null}
					assessmentBehavior={assessmentBehavior}
					handleAssessmentBehaviorChange={handleAssessmentBehaviorChange}
					notefollowUp={notefollowUp}
					onFollowUpChange={onFollowUpChange}
				/>
			)}
		</div>
	);
};
export default Dashboard;
